import {
    type FC
} from "react";
import {
    Platform,
    View
} from "react-native";
import type IAttachmentTitleProps from "./type";
import stylesheet from "./stylesheet";
import type {
    AttachmentPartContentProps
} from "../../type";
import {
    getAttachmentNameParts,
    isAttachmentNameRtl
} from "../../util";
import {
    withAttachmentContext
} from "../../context";
import Text from "../../../text";

const AttachmentTitleContent: FC<AttachmentPartContentProps<IAttachmentTitleProps>> = ({
    customTheme,
    children,
    context,
    style,
    ...props
}) => {
    const title = children ?? context.title;

    const {
        extension,
        stem
    } = getAttachmentNameParts({
        title
    });

    const isLatin = !isAttachmentNameRtl({
        title
    });

    const webDirectionProps = Platform.OS === "web" && isLatin ? {
        dir: "ltr"
    } : {};

    return <View
        {...webDirectionProps}
        {...props}
        style={[
            style,
            stylesheet.container,
            isLatin ? stylesheet.latin : undefined
        ]}
    >
        <Text
            customTheme={customTheme ?? context.customTheme}
            customColor={context.currentColors.titleColor}
            variant={context.currentSize.titleVariant}
            style={stylesheet.stem}
            numberOfLines={1}
        >
            {stem}
        </Text>
        {
            extension ?
                <Text
                    customTheme={customTheme ?? context.customTheme}
                    customColor={context.currentColors.titleColor}
                    variant={context.currentSize.titleVariant}
                    style={stylesheet.extension}
                >
                    {extension}
                </Text>
            :
                null
        }
    </View>;
};
export default withAttachmentContext("Title", AttachmentTitleContent);
